module.exports = __webpack_public_path__ + "assets/img/Level-2.c3a83c86.png";